<script setup>
const device = useDevice()
</script>

<template>
  <slot v-if="device.isH5" name="h5"></slot>
  <slot v-else name="pc"></slot>
  <slot></slot>
</template>
